module.exports = __webpack_public_path__ + "static/media/Baku.8b9f36a8.jpg";